<template>
  <div>
    <div>
      <div class="page-title-cont">
        <h1 class="wp-heading-inline">
          WPCal.io - {{ T__("Profile Settings") }}
        </h1>
        <AdminHeaderRight />
      </div>
      <SettingsMenu />
      <div class="col-cont settings-cont">
        <div class="col">
          <div class="form">
            <div class="validation_errors_cont"></div>
            <div class="setting-group-title">{{ T__("My profile") }}</div>
            <form-row :validator="$v.profile_settings.first_name">
              <label
                >{{ T__("First name")
                }}<abbr class="required" title="required">*</abbr>
                <em>{{ T__("required") }}</em></label
              >
              <input type="text" v-model="profile_settings.first_name" />
            </form-row>

            <form-row :validator="$v.profile_settings.last_name">
              <label
                >{{ T__("Last name")
                }}<abbr class="required" title="required">*</abbr>
                <em>{{ T__("required") }}</em></label
              >
              <input type="text" v-model="profile_settings.last_name" />
            </form-row>

            <form-row :validator="$v.profile_settings.display_name">
              <label
                >{{ T__("Display name")
                }}<abbr class="required" title="required">*</abbr>
                <em>{{ T__("required") }}</em></label
              >
              <input type="text" v-model="profile_settings.display_name" />
            </form-row>

            <form-row :validator="$v.profile_settings.display_name">
              <label
                >{{ T__("Avatar")
                }}<abbr class="required" title="required">*</abbr>
                <em>{{ T__("required") }}</em></label
              >

              <div
                style="display:flex; align-items: center; margin-bottom: 30px;"
              >
                <div>
                  <img
                    style="border-radius:50%;border: 3px solid #fff;box-shadow: 0 0 0 1px #b1b6d1;"
                    :src="avatar_details.url"
                    :width="
                      parseInt(avatar_details.width) &&
                      parseInt(avatar_details.width) > 75
                        ? 75
                        : avatar_details.width
                    "
                  />
                  <div
                    style="font-size: 11px; font-style:italic; color: #7c7d9c;text-align: center; position: absolute; width: 81px;"
                    v-if="avatar_details.is_gravatar"
                  >
                    {{ T__("Your Gravatar") }}
                  </div>
                </div>
                <div style="margin-left: 10px;">
                  <a @click="open_media_lib" style="padding:10px;">{{
                    T__("Change Pic")
                  }}</a
                  ><a
                    style="padding:10px;"
                    v-if="!avatar_details.is_gravatar"
                    @click="use_gravatar"
                    >{{ T__("Use my Gravatar") }}</a
                  >
                </div>
              </div>
            </form-row>

            <div class="wpc-form-row">
              <button
                type="button"
                class="wpc-btn primary lg mt20"
                @click="form_submit"
                style="width:100%"
                :disabled="!save_btn_is_enabled"
              >
                {{ T__("Save") }}
              </button>
            </div>
          </div>
          <AdminInfoLine info_slug="ownership_settings_profile" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsMenu from "@/components/admin/SettingsMenu.vue";
import { on_before_leave_alert_if_unsaved } from "@/utils/on_before_leave_alert_if_unsaved_mixin.js";

import axios from "axios";

import { required } from "vuelidate/lib/validators";

export default {
  mixins: [
    on_before_leave_alert_if_unsaved(
      "saved_profile_settings",
      "profile_settings"
    )
  ],
  components: {
    SettingsMenu
  },
  data() {
    return {
      document_title: this.T__("Profile ‹ Settings"),
      profile_settings: {
        first_name: "",
        last_name: "",
        display_name: "",
        avatar_attachment_id: ""
      },
      saved_profile_settings: this.clone_deep(this.profile_settings), //to avoid console error on initial rendering.
      avatar_details: {},
      is_refresh_avatar: false,
      save_btn_is_enabled: true
    };
  },
  validations: {
    profile_settings: {
      first_name: { required },
      last_name: { required },
      display_name: { required }
    }
  },
  methods: {
    open_media_lib(e) {
      let this_v = this;
      e.preventDefault();
      let image = wp
        .media({
          title: this.T__("Upload Image"),
          // mutiple: true if you want to upload multiple files at once
          multiple: false
        })
        .open()
        .on("select", function(e) {
          // This will return the selected image from the Media Uploader, the result is an object
          let uploaded_image = image
            .state()
            .get("selection")
            .first();
          // We convert uploaded_image to a JSON object to make accessing it easier
          // Output to the console uploaded_image
          //console.log("here we go", uploaded_image);
          this_v.is_refresh_avatar = true;
          this_v.profile_settings.avatar_attachment_id = uploaded_image.id; //.toJSON().url;
          // Let's assign the url value to the input field
          //$("#image_url").val(image_url);
        });
    },
    get_avatar_attachment(attachment_id) {
      let wpcal_request = {};
      let action_get_avatar_attachment =
        "get_admin_avatar_override_of_current_admin";
      wpcal_request[action_get_avatar_attachment] = {
        override_attachment_id: attachment_id
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          if (
            response.data[action_get_avatar_attachment]?.status == "success"
          ) {
            this.is_refresh_avatar = false;

            this.avatar_details =
              response.data[action_get_avatar_attachment].avatar_details;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    use_gravatar() {
      this.is_refresh_avatar = true;
      this.profile_settings.avatar_attachment_id = "";
    },
    load_page() {
      let wpcal_request = {};
      let action_get_profile_settings =
        "get_admin_profile_settings_of_current_admin";
      wpcal_request[action_get_profile_settings] = "dummy__";

      let action_get_avatar = "get_admin_avatar_of_current_admin";
      wpcal_request[action_get_avatar] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          if (response.data[action_get_profile_settings]?.status == "success") {
            this.profile_settings =
              response.data[action_get_profile_settings].profile_settings;
            this.saved_profile_settings = this.clone_deep(
              this.profile_settings
            );
          }
          if (response.data[action_get_avatar]?.status == "success") {
            this.is_refresh_avatar = false;
            this.avatar_details =
              response.data[action_get_avatar].avatar_details;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    form_submit() {
      this.clear_validation_errors_cont();
      this.$v.profile_settings.$touch();
      if (this.$v.profile_settings.$anyError) {
        this.scroll_to_first_validation_error();
        return false;
      }
      this.save_btn_is_enabled = false;

      let wpcal_request = {};

      let action_update_profile_settings =
        "update_admin_profile_settings_of_current_admin";
      wpcal_request[action_update_profile_settings] = {
        profile_settings: this.profile_settings
      };

      let action_get_profile_settings =
        "get_admin_profile_settings_of_current_admin";
      wpcal_request[action_get_profile_settings] = "dummy__";

      let action_get_avatar = "get_admin_avatar_of_current_admin";
      wpcal_request[action_get_avatar] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          this.notify_single_action_result(
            response.data[action_update_profile_settings],
            { success_msg: this.T__("Settings saved.") }
          );

          if (response.data[action_get_profile_settings]?.status == "success") {
            this.profile_settings =
              response.data[action_get_profile_settings].profile_settings;
            this.saved_profile_settings = this.clone_deep(
              this.profile_settings
            );
          }
          if (response.data[action_get_avatar]?.status == "success") {
            this.is_refresh_avatar = false;
            this.avatar_details =
              response.data[action_get_avatar].avatar_details;
          }
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.save_btn_is_enabled = true;
        });
    }
  },
  watch: {
    "profile_settings.avatar_attachment_id": function(new_value, old_value) {
      if (this.is_refresh_avatar) {
        this.get_avatar_attachment(new_value);
      }
    }
  },
  mounted() {
    this.load_page();
  }
};
</script>
